import React, { useEffect, useState } from "react";
import { FaEraser, FaUpload } from "react-icons/fa";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";

const columnKeys = [
  "F_YEAR",
  "YEAR",
  "A_MONTH",
  "F_MONTH",
  "AF_ID",
  "ZONE",
  "DIVISION",
  "ASSET_GROUP",
  "MAIN_CAUSE",
  "MAIN_CAUSE_DESC",
  "SUB_CAUSE",
  "SUB_CAUSE_DESC",
  "8TYPE_OF_FAILUR",
  "9FAILUR_DATE_TIMEFROM",
  "10FAILUR_DATE_TIMETO",
  "11DURATION",
  "COA_SECTION",
  "BLOCK_SECTION_STATION",
  "UP_DOWN",
  "AVARAGE_DET_TOTAL_TIME",
  "SHIFT",
  "No_of_Trains_DelayedP_15",
  "No_of_Trains_DelayedG_16",
  "No_of_Trains_DelayedTotal_17",
  "Average_Detention_Time_18",
  "Average_Detention_Time_G_19",
  "Average_Detention_Time_Mins_Total_20",
  "N3",
  "N4",
  "N6",
];

const createRow = () => {
  const obj = {};

  columnKeys.forEach((key) => {
    obj[key] = "";
  });

  return obj;
};

const AssetFailureInsertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([createRow()]);
  const [loading, setLoading] = useState(false);

  // FORMAT DATE
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";

    // expected input: 01/04/2026 00:00
    const [datePart, timePart] = dateStr.split(" ");

    if (!datePart) return dateStr;

    const [day, month, year] = datePart.split("/");

    // return formatted date
    return `${year}/${month}/${day} ${timePart || "00:00"}`;
  };

  // INPUT CHANGE
  const handleChange = (rowIndex, key, value) => {
    const updatedRows = [...rows];

    // format date columns
    if (key === "9FAILUR_DATE_TIMEFROM" || key === "10FAILUR_DATE_TIMETO") {
      value = formatDateTime(value);
    }

    updatedRows[rowIndex][key] = value;

    setRows(updatedRows);
  };

  // ROW COUNT
  const handleRowCount = (e) => {
    const count = Number(e.target.value);

    if (count < 0 || count > 1000) return;

    const newRows = Array.from({ length: count }, (_, i) => {
      return rows[i] || createRow();
    });

    setRows(newRows);
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData
      .getData("text")
      .split("\n")
      .filter((row) => row.trim() !== "") // REMOVE EMPTY ROW
      .map((row) => row.split("\t"));

    const updatedRows = [...rows];

    pastedData.forEach((row, rowIndex) => {
      if (!updatedRows[rowIndex]) {
        updatedRows[rowIndex] = createRow();
      }

      row.forEach((cell, colIndex) => {
        const key = columnKeys[colIndex];

        if (key) {
          let value = cell.trim();

          if (
            key === "9FAILUR_DATE_TIMEFROM" ||
            key === "10FAILUR_DATE_TIMETO"
          ) {
            value = formatDateTime(value);
          }

          updatedRows[rowIndex][key] = value;
        }
      });
    });

    setRows(updatedRows);
  };

  const clearAll = () => {
    setRows([createRow()]);
  };

  const sendToBackend = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${urlPrefix}insert/assetsFailure`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rows),
      });

      const dataResult = await response.json();

      setResult(dataResult);
      setLoading(false);
      setShow(true);
    } catch (error) {
      setLoading(false);
      console.error("Error sending data:", error);
    }
  };

  useEffect(() => {
    if (result?.message === "t_asset_failure details inserted successfully") {
      clearAll();
    }
  }, [result]);

  return (
    <div className="mt-3 p-3">
      <div className="papaDiv text-start ms-3 me-3">
        <h4 className="ms-4">
          <MdInsertChart /> Asset Failure
        </h4>

        <h5 className="ps-2">
          Insert data in table <b style={{ color: "red" }}>"Asset Failure"</b>
        </h5>
      </div>

      <div className="mb-3">
        Add Rows :
        <input
          type="number"
          min="1"
          max="1000"
          value={rows.length}
          onChange={handleRowCount}
          className="ms-2"
        />
      </div>

      <div className="table-responsive" style={{ height: "600px" }}>
        <table
          className="table table-striped table-hover"
          border="1"
          cellPadding="1"
          onPaste={handlePaste}
        >
          <thead>
            <tr className="table-dark" style={{ fontSize: "12px" }}>
              {columnKeys.map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columnKeys.map((key) => (
                  <td key={key} style={{ border: "1px solid gray" }}>
                    <input
                      type="text"
                      value={row[key]}
                      onChange={(e) =>
                        handleChange(rowIndex, key, e.target.value)
                      }
                      style={{ width: "120px" }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MESSAGE */}
      <div className="p-3">
        {result?.message === "t_asset_failure details inserted successfully" ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          <FailedMsg
            head="Failed"
            message={`${result?.message || ""} ${result?.error || ""}`}
            show={show}
            setShow={setShow}
          />
        )}
      </div>

      {/* BUTTONS */}
      <div className="mt-3 d-flex justify-content-center">
        <button
          className="btn btn-outline-danger btn-sm me-2"
          onClick={clearAll}
        >
          <FaEraser /> Clear
        </button>

        <button
          className="btn btn-outline-success btn-sm"
          onClick={sendToBackend}
          disabled={loading}
        >
          <FaUpload /> {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
};

export default AssetFailureInsertion;
